import {
  Download,
  Eye,
  HelpCircle,
  Loader2,
  Play,
  Printer,
  RotateCcw,
} from "lucide-react";

export default function TdsReportsActionBar({
  onGenerate,
  onPreview,
  onReset,
  onExport,
  onPrint,
  onHelp,
  generating,
  disabled,
}) {
  return (
    <div className="tdsr-action-bar" role="toolbar" aria-label="Report actions">
      <button
        type="button"
        className="tds-btn tds-btn--primary"
        onClick={onGenerate}
        disabled={disabled || generating}
      >
        {generating ? <Loader2 size={16} className="animate-spin" /> : <Play size={16} />}
        Generate Report
      </button>
      <button type="button" className="tds-btn tds-btn--secondary" onClick={onPreview} disabled={disabled}>
        <Eye size={16} />
        Preview
      </button>
      <button type="button" className="tds-btn tds-btn--secondary" onClick={onReset}>
        <RotateCcw size={16} />
        Reset
      </button>
      <button type="button" className="tds-btn tds-btn--secondary" onClick={onExport} disabled={disabled}>
        <Download size={16} />
        Export
      </button>
      <button type="button" className="tds-btn tds-btn--secondary" onClick={onPrint} disabled={disabled}>
        <Printer size={16} />
        Print
      </button>
      <button type="button" className="tds-btn tds-btn--ghost" onClick={onHelp}>
        <HelpCircle size={16} />
        Help
      </button>
    </div>
  );
}
